import React from 'react';
import MediaPrimary, { ImagePrimaryProps as MediaPrimaryProps } from '../Media/MediaPrimary';
import { VideoItemProps } from './VideoListing';
import VideoDetails from './VideoDetails.Helper';

const PLAYER_REGION_ID = 'video-player-region';

const VideoPlayer = ({
  video,
  videoPlayerClasses,
  playerRegion,
}: {
  video: VideoItemProps;
  videoPlayerClasses: { [key: string]: string };
  playerRegion?: React.RefObject<HTMLDivElement>;
}) => {
  return (
    <>
      <div
        id={PLAYER_REGION_ID}
        ref={playerRegion}
        role="region"
        aria-label="Video Player"
        tabIndex={-1}
        className={videoPlayerClasses?.videoWrapper}
      >
        <MediaPrimary {...(video as unknown as MediaPrimaryProps)} />
      </div>
      <VideoDetails
        isVideoPlayerItem={true}
        videoDetailsClasses={videoPlayerClasses}
        videoItem={video}
      />
    </>
  );
};

export default React.memo(VideoPlayer);

export { PLAYER_REGION_ID };
